import React, { useState } from "react";
import classes from "./Profile.module.css";
import Header from "../../Components/Header/Header";
import Sidebar from "../../Components/Sidebar/Sidebar";

const Profile = () => {
    const [activeTab, setActiveTab] = useState("personal");
    const [isEditPersonalInfoOpen, setIsEditPersonalInfoOpen] = useState(false);
    const [isChangePasswordOpen, setIsChangePasswordOpen] = useState(false);

    // Personal info state
    const [userInfo, setUserInfo] = useState({
        fullName: "Adekunle O.",
        email: "adekunle@pentsuite.com",
        role: "Super Admin",
        phone: "+234 812 345 6789",
    });

    // Temp form state for personal info edit modal
    const [editForm, setEditForm] = useState({ ...userInfo });

    // Password form state
    const [passwordForm, setPasswordForm] = useState({
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
    });

    const handlePersonalInfoSubmit = (e) => {
        e.preventDefault();
        setUserInfo({ ...editForm });
        setIsEditPersonalInfoOpen(false);
    };

    const handlePasswordSubmit = (e) => {
        e.preventDefault();
        if (passwordForm.newPassword !== passwordForm.confirmPassword) {
            alert("New passwords do not match!");
            return;
        }
        // Process password update API call here
        setIsChangePasswordOpen(false);
        setPasswordForm({ currentPassword: "", newPassword: "", confirmPassword: "" });
    };

    return (
        <div className={classes.page}>
            <Header />
            <Sidebar />

            <main className={classes.main}>
                <div className={classes.container}>
                    {/* Top Bar */}
                    <div className={classes.topBar}>
                        <div>
                            <h2 className={classes.welcome}>Account Settings</h2>
                            <p style={{ marginTop: 0, fontWeight: "400", fontSize: "14px", color: "#1E293B" }}>
                                Manage your profile information and account security options
                            </p>
                        </div>
                    </div>

                    {/* Profile Header Summary Card */}
                    <div className={classes.profileHeaderCard}>
                        <div className={classes.avatarCircle}>AO</div>
                        <div>
                            <h3 className={classes.profileName}>{userInfo.fullName}</h3>
                            <p className={classes.profileRole}>{userInfo.role}</p>
                        </div>
                    </div>

                    {/* Tabs Navigation */}
                    <div className={classes.tabsContainer}>
                        <button
                            type="button"
                            className={`${classes.tabButton} ${activeTab === "personal" ? classes.activeTab : ""}`}
                            onClick={() => setActiveTab("personal")}
                        >
                            Personal Information
                        </button>
                        <button
                            type="button"
                            className={`${classes.tabButton} ${activeTab === "security" ? classes.activeTab : ""}`}
                            onClick={() => setActiveTab("security")}
                        >
                            Security
                        </button>
                    </div>

                    {/* Tab 1: Personal Information */}
                    {activeTab === "personal" && (
                        <div className={classes.contentCard}>
                            <div className={classes.cardHeader}>
                                <div>
                                    <h3 className={classes.cardTitle}>Personal Details</h3>
                                    <p className={classes.cardSubtext}>Your basic profile details across the workspace.</p>
                                </div>
                                <button
                                    type="button"
                                    className={classes.actionBtnPrimary}
                                    onClick={() => {
                                        setEditForm({ ...userInfo });
                                        setIsEditPersonalInfoOpen(true);
                                    }}
                                >
                                    Edit Details
                                </button>
                            </div>

                            <div className={classes.infoGrid}>
                                <div className={classes.infoGroup}>
                                    <span className={classes.infoLabel}>Full Name</span>
                                    <span className={classes.infoValue}>{userInfo.fullName}</span>
                                </div>
                                <div className={classes.infoGroup}>
                                    <span className={classes.infoLabel}>Email Address</span>
                                    <span className={classes.infoValue}>{userInfo.email}</span>
                                </div>
                                <div className={classes.infoGroup}>
                                    <span className={classes.infoLabel}>Role</span>
                                    <span className={classes.infoValue}>{userInfo.role}</span>
                                </div>
                                <div className={classes.infoGroup}>
                                    <span className={classes.infoLabel}>Phone Number</span>
                                    <span className={classes.infoValue}>{userInfo.phone}</span>
                                </div>
                            </div>
                        </div>
                    )}

                    {/* Tab 2: Security */}
                    {activeTab === "security" && (
                        <div className={classes.contentCard}>
                            <div className={classes.cardHeader}>
                                <div>
                                    <h3 className={classes.cardTitle}>Password & Security</h3>
                                    <p className={classes.cardSubtext}>Manage your password and authentication settings.</p>
                                </div>
                                <button
                                    type="button"
                                    className={classes.actionBtnPrimary}
                                    onClick={() => setIsChangePasswordOpen(true)}
                                >
                                    Change Password
                                </button>
                            </div>

                            <div className={classes.securityRow}>
                                <div>
                                    <div className={classes.securityItemTitle}>Password</div>
                                    <div className={classes.securityItemSub}>Last updated 30 days ago</div>
                                </div>
                                <div className={classes.maskedPassword}>••••••••••••</div>
                            </div>
                        </div>
                    )}
                </div>
            </main>

            {/* Modal: Edit Personal Info */}
            {isEditPersonalInfoOpen && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modalCard}>
                        <div className={classes.modalHeader}>
                            <h3>Edit Personal Information</h3>
                            <button
                                type="button"
                                className={classes.closeBtn}
                                onClick={() => setIsEditPersonalInfoOpen(false)}
                            >
                                ✕
                            </button>
                        </div>
                        <form onSubmit={handlePersonalInfoSubmit} className={classes.modalForm}>
                            <div className={classes.inputGroup}>
                                <label htmlFor="fullName">Full Name</label>
                                <input
                                    id="fullName"
                                    type="text"
                                    value={editForm.fullName}
                                    onChange={(e) => setEditForm({ ...editForm, fullName: e.target.value })}
                                    required
                                />
                            </div>
                            <div className={classes.inputGroup}>
                                <label htmlFor="email">Email Address</label>
                                <input
                                    id="email"
                                    type="email"
                                    value={editForm.email}
                                    onChange={(e) => setEditForm({ ...editForm, email: e.target.value })}
                                    required
                                />
                            </div>
                            <div className={classes.inputGroup}>
                                <label htmlFor="phone">Phone Number</label>
                                <input
                                    id="phone"
                                    type="text"
                                    value={editForm.phone}
                                    onChange={(e) => setEditForm({ ...editForm, phone: e.target.value })}
                                    required
                                />
                            </div>
                            <div className={classes.modalActions}>
                                <button
                                    type="button"
                                    className={classes.actionBtnSecondary}
                                    onClick={() => setIsEditPersonalInfoOpen(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className={classes.actionBtnPrimary}>
                                    Save Changes
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Modal: Change Password */}
            {isChangePasswordOpen && (
                <div className={classes.modalOverlay}>
                    <div className={classes.modalCard}>
                        <div className={classes.modalHeader}>
                            <h3>Change Password</h3>
                            <button
                                type="button"
                                className={classes.closeBtn}
                                onClick={() => setIsChangePasswordOpen(false)}
                            >
                                ✕
                            </button>
                        </div>
                        <form onSubmit={handlePasswordSubmit} className={classes.modalForm}>
                            <div className={classes.inputGroup}>
                                <label htmlFor="currentPassword">Current Password</label>
                                <input
                                    id="currentPassword"
                                    type="password"
                                    placeholder="Enter current password"
                                    value={passwordForm.currentPassword}
                                    onChange={(e) =>
                                        setPasswordForm({ ...passwordForm, currentPassword: e.target.value })
                                    }
                                    required
                                />
                            </div>
                            <div className={classes.inputGroup}>
                                <label htmlFor="newPassword">New Password</label>
                                <input
                                    id="newPassword"
                                    type="password"
                                    placeholder="Enter new password"
                                    value={passwordForm.newPassword}
                                    onChange={(e) =>
                                        setPasswordForm({ ...passwordForm, newPassword: e.target.value })
                                    }
                                    required
                                />
                            </div>
                            <div className={classes.inputGroup}>
                                <label htmlFor="confirmPassword">Confirm New Password</label>
                                <input
                                    id="confirmPassword"
                                    type="password"
                                    placeholder="Confirm new password"
                                    value={passwordForm.confirmPassword}
                                    onChange={(e) =>
                                        setPasswordForm({ ...passwordForm, confirmPassword: e.target.value })
                                    }
                                    required
                                />
                            </div>
                            <div className={classes.modalActions}>
                                <button
                                    type="button"
                                    className={classes.actionBtnSecondary}
                                    onClick={() => setIsChangePasswordOpen(false)}
                                >
                                    Cancel
                                </button>
                                <button type="submit" className={classes.actionBtnPrimary}>
                                    Update Password
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Profile;